module.exports = __webpack_public_path__ + "static/media/accesorios-barandales-slide-1.e790b036.png";